<template>
  <div class="my-trade-wrap">
    <div class="module">
      <div class="module-body">
        <v-tabs v-model="selectedTab" background-color="#1d2b35" active-class="tab-active">
          <v-tab v-for="(tab, index) in tabs" :key="index">
            {{ tab.label }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab">
          <v-tab-item v-for="(tab, index) in tabs" :key="index">
            <div v-if="tab.id === 1">
              <div
                class="d-flex justify-end cancel-btn-wrap pt-3 pb-3 pr-8"
                v-if="!isNaN(Getter_User_Info.id) && 999999 > Number(Getter_User_Info.id)"
              >
                <div class="cancel-btn" :class="{ disabled: cancelOrderCommitting }" v-ripple @click="_showCancelAllModal">
                  {{ $t('actions.tradeCancelAll') }}
                </div>
              </div>
              <OpenOrderTable
                :data="currentEntrust.data"
                :loading="currentEntrust.loading"
                :pagination-config.sync="currentEntrust.query"
                @showCancelOrderModal="_cancelOrderModalShow"
              />
            </div>
            <HistoryOrderTable
              v-else-if="tab.id === 2"
              :data="historyEntrust.data"
              :loading="historyEntrust.loading"
              :pagination-config.sync="historyEntrust.query"
            />
          </v-tab-item>
        </v-tabs-items>

        <!-- <div class="cancel-btn cancel-all-btn"
             :class="{disabled: cancelAllCommitting || currentEntrust.list.length == 0}"
             v-ripple
             v-show="selectedTab == 'tab-1'"
        @click="_showCancelAllModal">批量撤销</div>-->
      </div>
    </div>

    <!-- Cancel order -->
    <ConfirmModal
      v-if="cancelOrderModalShow"
      :show.sync="cancelOrderModalShow"
      :loading="cancelOrderCommitting"
      :content="$t('trade.cancel.confirm')"
      @submit="cancelOrderBtnClick"
    />

    <!-- Cancel all order -->
    <ConfirmModal
      v-if="cancelAllModalShow"
      :show.sync="cancelAllModalShow"
      :loading="cancelAllCommitting"
      :content="$t('trade.cancel.confirm')"
      @submit="cancelAllBtnClick"
    />

    <MessageModal
      v-if="matchOrderModalShow"
      :show.sync="matchOrderModalShow"
      :content="$t('trade.match.success').replace('{number}', matchCount)"
      @close="onMatchOrderModalHide"
    />

    <!--批量撤销弹窗 start-->
    <!-- <BootstrapModal @onhide="onCancelOrderModalHide" v-model="cancelAllModalShow" :small="true" :title="$t('labels.reminder')">
      <p class="color-333">{{ $t('trade.cancel.confirm') }}</p>
      <div class="text-right pt-5">
        <q-btn
          :label="$t('actions.confirm')"
          class="no-shadow"
          :loading="cancelAllCommitting"
          color="primary"
          @click="cancelAllBtnClick"
        />
      </div>
    </BootstrapModal> -->
    <!--批量撤销弹窗 end-->

    <!--撤销单个订单弹窗 start-->
    <!-- <BootstrapModal @onhide="onCancelOrderModalHide" v-model="cancelOrderModalShow" :small="true" :title="$t('labels.reminder')">
      <p class="color-333">{{ $t('trade.cancel.confirm') }}</p>
      <div class="text-right pt-5">
        <q-btn
          :label="$t('actions.confirm')"
          class="no-shadow"
          :loading="cancelOrderCommitting"
          color="primary"
          @click="cancelOrderBtnClick"
        />
      </div>
    </BootstrapModal> -->
    <!--撤销单个订单弹窗 end-->
    <!--Match订单弹窗 start-->
    <!-- <BootstrapModal @onhide="onMatchOrderModalHide" v-model="matchOrderModalShow" :small="true" :title="$t('labels.reminder')">
      <p class="color-333">{{ $t('trade.match.success').replace('{number}', matchCount) }}</p>
      <div class="text-right pt-5">
        <q-btn
          :label="$t('actions.close')"
          class="no-shadow"
          color="primary"
          @click="onMatchOrderModalHide"
        />
      </div>
    </BootstrapModal> -->
    <!--Match订单弹窗 end-->
  </div>
</template>

<script>
  import index from './my-trade.js';

  export default index;
</script>

<style lang="stylus" scoped>
  @import 'my-trade.styl'

  .mini-loading {
    color: #7a838f;
    height: 22px;
    padding-left: 35px;
    padding-right: 35px;
    text-align: right;
  }
</style>
